import { useEffect } from 'react';

// Canonical/OG URLs must always point at the production domain — never the
// preview/staging origin — so Google indexes the right host.
export const SITE_ORIGIN = 'https://amden.ie';

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

export function useSeo({ title, description, canonical, ogImage, jsonLd, robots }) {
  const json = jsonLd ? JSON.stringify(jsonLd) : null;

  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta('property', 'og:title', title);
    }
    if (description) {
      setMeta('name', 'description', description);
      setMeta('property', 'og:description', description);
    }
    if (ogImage) setMeta('property', 'og:image', ogImage);
    // Private routes (booking management, confirmations) must not be indexed.
    if (robots) setMeta('name', 'robots', robots);

    if (canonical) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = canonical;
    }

    let script;
    if (json) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.dataset.pageJsonld = 'true';
      script.textContent = json;
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
    };
  }, [title, description, canonical, ogImage, json, robots]);
}
